module.exports = __webpack_public_path__ + "img/assets/caption-corner.svg";